/**
 * Глобальная переменная App
 */

window.App = {
    W: $(window),
    H: $('html'),
    D: $(document),
    ie: false,
    edge: false,
    firefox: false
};


/**
 * Глобальные классы для браузеров
 */
{
    const html = document.getElementsByTagName('html')[0];

    if (html.classList.contains('mobile')) {
        App.mobile = true;
    } else if (html.classList.contains('safari') && 'ontouchstart' in window) {
        /**
         * В iPadOS сафари определяется как десктопный,
         * исправляем это
         */
        App.mobile = true;
        html.classList.remove('osx');
        html.classList.add('mobile', 'ios');
    } else {
        html.classList.add('desktop');
    }

    if (html.classList.contains('ie')) {
        App.ie = true;
    }

    if (html.classList.contains('edge')) {
        App.edge = true;
    }

    if (html.classList.contains('firefox')) {
        App.firefox = true;
    }
}



// WEBPACK FOOTER //
// ./_src/js/App.js